import { useStore } from 'zustand';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { useMemo } from 'react';

import { Button } from '@/components/ui/button/button.component';
import { addressFormatter } from '@/utils/formatters/format-address';
import { authStore } from '@/store/auth.store';
import { CustomerAddress } from '@/types/auth-base.types';
import { Typography } from '@/components/ui/typography/typography.component';

type RegisterAddressProps = {
  handleRegisterAddressClick: (address: CustomerAddress) => Promise<void>;
};

export const RegisterAddress = ({ handleRegisterAddressClick }: RegisterAddressProps) => {
  const address = useStore(authStore, (state) => state.authenticatedUser?.address);

  const formattedAddress = useMemo(() => {
    if (!address) {
      return '';
    }

    return addressFormatter(address, 'full');
  }, [address]);

  if (!address) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4" data-testid="register-address--location-modal">
      <Typography className="font-semibold">Endereço de cadastro</Typography>
      <Button
        variant="text"
        className="hover:no-underline justify-start items-center gap-2 text-gray-600 text-left font-medium leading-5 text-wrap"
        onClick={() => handleRegisterAddressClick(address)}
        startIcon={faLocationDot}
        startIconClassName="justify-center self-center text-gray-400 text-base ml-1"
        startIconSize="1x"
      >
        {formattedAddress}
      </Button>
    </div>
  );
};
